import {Component, OnInit} from '@angular/core';
import {BannerService} from '@services/banner/banner.service';
import {PageAction} from '../../components/page-actions/page-actions.component';
import {Router} from '@angular/router';
import {DataTableEvent} from '../../components/data-table/data-table.component';
import { moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    providers: [BannerService],
    standalone: false
})

export class BannerComponent implements OnInit {

  public title = 'Banners';

  public pageActions: PageAction[];
  public banners;

  constructor(public bannerService: BannerService, private router: Router) {
  }

  async ngOnInit() {
    this.banners = (await this.bannerService.find(0, 100, {}))?.data;
    this.banners = this.banners.sort((b1, b2) => {
      return (b1?.order || 0) - (b2?.order || 0);
    });
    this.pageActions = [new PageAction({ icon: 'add', title: 'Create Banner', callback: () => {this.router.navigate(['banner/create'])} })];
  }

  public edit(item): void {
    this.router.navigate(['banner', item._id, 'edit']);
  }

  async drop(event) {
    moveItemInArray(this.banners, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.banners.length; i++) {
      this.bannerService.patch(this.banners[i]._id, { order: i });
    }
  }
}
